export interface codigoNoIngreso {
  codigo: number;
  texto: string;
}
export const ListaCodigoNoIngreso: codigoNoIngreso[] = [
  { codigo: 1, texto: 'El usuario no existe o es un Qr obsoleto' },
  { codigo: 2, texto: 'El usuario esta bloqueado' },
  { codigo: 3, texto: 'El usuario esta inactivo' },
  { codigo: 4, texto: 'El usuario no esta asignado a un club' },
  { codigo: 5, texto: 'El club esta deshabilitado' },
  { codigo: 6, texto: 'El club esta deshabilitado por fecha de servicio' },
  { codigo: 7, texto: 'Código no actualizado (pago)' },
  { codigo: 8, texto: 'Código ya utilizado para un ingreso' },
  { codigo: 9, texto: 'El deportista no tiene una disciplina asignada' },
  { codigo: 10, texto: 'El deportista no tiene horarios' },
  { codigo: 11, texto: 'No tiene horario para hoy' },
  { codigo: 12, texto: 'Tiene horario pero entra antes de la hora permitida' },
  { codigo: 14, texto: '14 - El horario del día ya ha terminado' },
  { codigo: 15, texto: '15 - El horario del día ya ha terminado' },
  { codigo: 16, texto: 'Error de lectura' },
  { codigo: 13, texto: 'El horario ya tiene su aforo máximo' },
];
